var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.91 511.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill-rule:evenodd;}.a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -618.48,
    y1: 44.12,
    x2: -257.43,
    y2: -316.98,
    gradientTransform: "matrix(1, 0, 0, -1, 689.01, 124.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -241.08,
    y1: -300.63,
    x2: -602.13,
    y2: 60.47,
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "json") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M255.66,381.14c113.26,154.39,224.09-43.09,223.93-161.85C479.4,78.88,337.08.41,255.57.41,124.74.41.14,108.54.14,256.48.14,420.92,143,512,255.57,512c-25.48-3.67-110.4-21.86-111.54-217.46-.77-132.28,43.15-185.13,111.36-161.88,1.52.56,75.23,29.64,75.23,124.62C330.62,351.85,255.66,381.14,255.66,381.14Z",
    transform: "translate(-0.14 -0.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M255.53,132.55C180.7,106.76,89,168.43,89,292c0,201.72,149.48,220,167.6,220,130.84,0,255.43-108.13,255.43-256.07C512.05,91.49,369.23.41,256.62.41c31.19-4.32,168.1,33.75,168.1,220.88,0,122-102.23,188.46-168.72,160.08-1.53-.57-75.23-29.65-75.23-124.62C180.77,162.17,255.53,132.55,255.53,132.55Z",
    transform: "translate(-0.14 -0.09)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.6195223b408e7af788b06bc0551950e9.svg";
export { ForwardRef as ReactComponent };